<div
  class="flex items-center w-full cursor-pointer hover:bg-accent-solid px-[10px] py-[6px] min-h-[36px]"
  role="option"
  [attr.aria-selected]="selected()"
  [attr.tabIndex]="0"
  [ngStyle]="{
    cursor: disabled() ? 'not-allowed' : 'pointer'
  }"
  (click)="onItemClicked()"
>
  <div
    class="flex flex-1 shrink justify-center items-center self-stretch my-auto text-sm font-semibold"
    [ngClass]="{
      'text-foreground': !disabled(),
      'text-foreground-50': disabled()
    }"
  >
    @if (leftIcon()) {
    <div class="flex items-center">
      <i [ngClass]="leftIcon()" class="leading-[0] h-[16px] w-[16px] text-[16px] text-muted-foreground"></i>
    </div>
    } @if (systemLeftIcon()) {
    <div class="flex items-center">
      <lib-system-icons
        [iconName]="systemLeftIcon()"
        [iconFill]="'fill-muted-foreground'"
        class="leading-[0] h-[16px] w-[16px] text-[16px]"
        [iconScale]="iconScale()"
      ></lib-system-icons>
    </div>
    } @if (checkbox()) {
    <div class="flex items-center">
      <lib-checkbox
        [(value)]="checkbox().checked"
        [partialSelected]="checkbox().partialSelected ?? false"
        [state]="disabled() ? 'disabled' : 'default'"
      >
      </lib-checkbox>
    </div>
    }

    <span class="flex-1 shrink self-stretch my-auto basis-0 whitespace-nowrap content-semibold px-[7px]">
      {{ text() | translate }}
      @if (secondaryText()) {
      <span class="block text-muted-foreground content-sm-regular leading-[20px]">{{
        secondaryText() | translate
      }}</span>
      }
    </span>

    @if (!checkbox()) { @if (!switch()) {
    <div class="flex items-center justify-center h-[20px] w-[20px]">
      @if (selected() && displaySelectedIcon()) {
      <i class="fi fi-rr-check text-primary leading-[16px] !text-[16px] !h-[16px] block"></i>
      } @if (rightIcon() && (!selected() || !displaySelectedIcon())) {
      <i [ngClass]="rightIcon()" class="leading-[0] text-[16px] text-muted-foreground"></i>
      }
    </div>
    } @if (switch()) {
    <div class="flex items-center">
      <lib-switch [value]="switchValue()" (valueChange)="switchValue.set($event)"></lib-switch>
    </div>
    } } @if (systemRightIcon()) {
    <div class="flex items-center">
      <lib-system-icons
        [iconName]="systemRightIcon()"
        [iconFill]="'fill-muted-foreground'"
        class="leading-[0] h-[16px] w-[16px] text-[16px]"
      ></lib-system-icons>
    </div>
    }
  </div>
</div>
